import { dictionaryApi } from './dictionaryClient';
import type { AmarkoshWord } from './amarkoshWordApi';
import type { AmarkoshWordSynonym } from './amarkoshWordSynonymApi';
import type { Subanta } from './subantaApi';

export type AmarkoshScalars = {
  num: string;
  text: string;
};

export type Amarkosh = AmarkoshScalars & {
  id: number;
  createdAt?: string;
  updatedAt?: string;
  created_at?: string;
  updated_at?: string;
};

/** Synonym row when loaded with `subanta` relation (e.g. GET /amarkosh/:id). */
export type AmarkoshWordSynonymWithSubanta = AmarkoshWordSynonym & {
  subanta?: Subanta;
};

/** Amarkosh word when loaded with `synonyms` (and nested subanta). */
export type AmarkoshWordWithSynonyms = AmarkoshWord & {
  synonyms?: AmarkoshWordSynonymWithSubanta[];
};

/** Full amarkosh payload from GET /amarkosh/:id including nested words → synonyms → subanta. */
export type AmarkoshWithWords = Amarkosh & {
  words?: AmarkoshWordWithSynonyms[];
};

export type CreateAmarkoshBody = AmarkoshScalars;

function normalizeList(data: unknown): Amarkosh[] {
  if (Array.isArray(data)) return data as Amarkosh[];
  if (data && typeof data === 'object' && Array.isArray((data as { data?: unknown }).data)) {
    return (data as { data: Amarkosh[] }).data;
  }
  return [];
}

export async function listAmarkosh(): Promise<Amarkosh[]> {
  const res = await dictionaryApi.get<unknown>('/amarkosh');
  return normalizeList(res.data);
}

export async function getAmarkosh(id: number): Promise<AmarkoshWithWords> {
  const res = await dictionaryApi.get<AmarkoshWithWords>(`/amarkosh/${id}`);
  return res.data;
}

export async function createAmarkosh(body: CreateAmarkoshBody): Promise<Amarkosh> {
  const res = await dictionaryApi.post<Amarkosh>('/amarkosh', body);
  return res.data;
}

export async function updateAmarkosh(
  id: number,
  body: Partial<AmarkoshScalars>
): Promise<Amarkosh> {
  const res = await dictionaryApi.patch<Amarkosh>(`/amarkosh/${id}`, body);
  return res.data;
}

export async function deleteAmarkosh(id: number): Promise<void> {
  await dictionaryApi.delete(`/amarkosh/${id}`);
}